/**/
import React from 'react';
import {Auth} from 'aws-amplify'

import Logo from '../../Images/Logo.png'
import LogoSmall from '../../Images/LogoSmall.png'

import {Link, withRouter} from 'react-router-dom'
import {Badge, Button, Icon, Layout, Menu, PageHeader, Popover} from 'antd'
import {connect} from "react-redux"
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors"

const {Header, Sider, Content, Footer} = Layout;

class BaseDocumentControl extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            menuState: false
        }

    }

    signout = () => {
        Auth.signOut({global: true})
            .then(data => {
                this.props.Logout()
                this.props.history.push("/login-dc")
            })
    }

    async onMenuClick(e) {
        if (e.key === "logout") {
            this.signout()
        } else {
            this.props.history.push("/" + e.key)
        }
    }

    itemRender(route, params, routes, paths) {
        const last = routes.indexOf(route) === routes.length - 1;
        return last ? (
            <span>{route.breadcrumbName}</span>
        ) : (
            <Link to={route.path}>{route.breadcrumbName}</Link>
        );
    }

    render() {

        if (this.props.login.user === null) return null

        const title = this.props.login.user.attributes.email;
        const content = (
            <div>
                <p>Mi cuenta</p>
                <Link to='/micuenta-adminlite'>Cambiar contraseña</Link>
                <p></p>

                <a href="#/" onClick={this.signout}>
                    <Icon
                        type={'logout'}
                    /> Salir
                </a>
            </div>
        );

        return (
            <Layout style={{height: "100vh"}}>
                <Sider
                    trigger={null}
                    collapsible
                    collapsed={this.state.menuState}
                    breakpoint="md"
                    onBreakpoint={
                        broken => {
                            this.setState({
                                collapsed: broken
                            })
                        }
                    }
                    style={{backgroundColor: "#49ECAD"}}
                >
                    <center><Link to='/'><img alt="logo" src={!this.state.menuState ? Logo : LogoSmall} className="logo"
                                              style={{height: "60px", marginTop: "15px", marginBottom: "15px"}}/></Link>
                    </center>
                    <Menu theme="dark" style={{backgroundColor: "#1C1B1B"}} mode="inline"
                          defaultSelectedKeys={[this.props.selected]} onClick={(e) => this.onMenuClick(e)}>
                        <Menu.Item key="document-control">
                            <Icon type="dashboard"/>
                            <span style={{fontSize: '0.9em'}}>General</span>
                        </Menu.Item>
                        <Menu.Item key="upload-document">
                            <Icon type="upload"/>
                            <span style={{fontSize: '0.9em'}}>Cargar Documento</span>
                        </Menu.Item>
                        <Menu.Item key="candidates">
                            <Icon type="user"/>
                            <span style={{fontSize: '0.9em'}}>Candidatos</span>
                        </Menu.Item> 
                        <Menu.Item key="documents">
                            <Icon type="file"/>
                            <span style={{fontSize: '0.9em'}}>Documentos</span>
                        </Menu.Item>
                        <Menu.Item key="document-types">
                            <Icon type="file"/>
                            <span style={{fontSize: '0.9em'}}>Tipo de Documentos</span>
                        </Menu.Item>
                        <Menu.Item key="logout">
                            <Icon type="logout"/>
                            <span style={{fontSize: '0.9em'}}>Cerrar sesión</span>
                        </Menu.Item>
                    </Menu>
                </Sider>
                <Layout>
                    <Header style={{background: 'linear-gradient(to right, #353FDF, #49ECAD)', padding: 0}}>
                        <Icon
                            className="trigger"
                            type={this.state.menuState ? 'menu-unfold' : 'menu-fold'}
                            onClick={() => this.setState({menuState: !this.state.menuState})}
                            style={{
                                color: "white",
                                fontSize: "18px",
                                lineHeight: "64px",
                                padding: "0 24px",
                                cursor: "pointer",
                                transition: "color 0.3s",
                            }}
                        />
                        <span style={{float: "right", padding: "0 24px"}}>
              {/*<Link to="/user-lite">*/}
              {/*  <Button type="default" icon="user" size={'small'} style={{ marginRight: "10px", fontWeight: 600 }}>*/}
              {/*    User Lite Panel*/}
              {/*  </Button>*/}
              {/*</Link>*/}
              <Popover
                  placement="bottomRight"
                  title={title}
                  content={content}
                  trigger="click"
              >
                <Badge dot>
                  <Button
                      icon="user"
                      shape="circle"
                  />
                </Badge>
              </Popover>
            </span>
                    </Header>
                    <Content
                        style={{
                            background: '#fff'
                        }}
                    >
                        <PageHeader
                            title={this.props.title}
                            breadcrumb={{
                                routes: this.props.routes,
                                separator: ">",
                                itemRender: this.itemRender
                            }}
                        >
                            {this.props.children}
                        </PageHeader>
                    </Content>
                    <Footer style={{textAlign: 'center', padding: 15}}>©2021 Liqui | All rights reserved.</Footer>
                </Layout>
            </Layout>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BaseDocumentControl));
